<template>
  <v-data-table-server
    v-model:options="options"
    dense
    :headers="headers"
    :loading="loading"
    :items="items"
    :items-length="totalItems"
    class="elevation-1"
    :items-per-page-options="footerProps.itemsPerPageOptions"
    @update:options="updateTable"
  >
    <template #top>
      <v-card-title>
        <v-toolbar flat>
          <v-toolbar-title>Cronjobs</v-toolbar-title>

          <v-spacer />

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            @input="searchTable()"
          />

          <v-spacer />

          <CronjobFormModal
            v-model="dialogForm"
            :edited-item="editedItem"
            @close-modal="closeModal('dialogForm')"
            @item-saved="itemSaved()"
            @click:outside="clearState()"
          />

          <v-btn
            v-if="hasPermission('create system-settings::cron-jobs')"
            dark
            class="mb-2 btn-bg-deep-blue"
            @click="dialogForm = true"
          >
            <v-icon>mdi-plus</v-icon>
            New Cronjob
          </v-btn>
          <disabled-for-lack-of-role-btn
            v-else
            text="New Cronjob"
            permission="create system-settings::cron-jobs"
            :x-small="false"
            button-class="mb-2"
          />

          <RunCronjobNowModal
            v-model="dialogCronNow"
            @close-modal="closeModal('dialogCronNow')"
            @click:outside="clearState()"
          />

          <v-btn
            v-if="hasPermission('create system-settings::cron-jobs')"
            dark
            class="mb-2 btn-bg-deep-blue ml-2"
            @click="showRunCronNow()"
          >
            <v-icon>mdi-console</v-icon>
            Run Cron now
          </v-btn>
          <disabled-for-lack-of-role-btn
            v-else
            text="Run Cron now"
            permission="create system-settings::cron-jobs"
            :x-small="false"
            button-class="mb-2"
          />
        </v-toolbar>
      </v-card-title>
    </template>

    <template #item.actions="{ item }">
      <v-icon
        v-if="hasPermission('edit system-settings::cron-jobs')"
        :id="item"
        class="mr-10"
        @click="editItem(item)"
      >
        mdi-pencil-outline
      </v-icon>
      <disabled-for-lack-of-role-btn
        v-else
        text=""
        icon="mdi-pencil-outline"
        :text-button="true"
        permission="edit system-settings::cron-jobs"
        :x-small="false"
        button-class="mr-10"
      />

      <CronjobToggle
        :item="item"
        @cronjob-toggled="updateTable"
      />
    </template>
  </v-data-table-server>
</template>

<script>
import dataTableMixin from '@/mixins/dataTableMixin.js';

import CronjobFormModal from '@/views/Settings/Cronjob/CronjobFormModal.vue';
import CronjobToggle from '@/views/Settings/Cronjob/CronjobToggle.vue';
import RunCronjobNowModal from '@/views/Settings/Cronjob/RunCronjobNowModal.vue';
import DisabledForLackOfRoleBtn from '../../DisabledForLackOfRoleBtn.vue';

export default {
  components: {
    RunCronjobNowModal,
    CronjobFormModal,
    CronjobToggle,
    DisabledForLackOfRoleBtn,
  },

  mixins: [
    dataTableMixin,
  ],

  data: () => ({
    headers: [
      { title: 'ID', value: 'id' },
      { title: 'Command', value: 'command' },
      { title: 'Schedule', value: 'schedule', sortable: false },
      { title: 'Actions', value: 'actions', sortable: false },
    ],

    dialogForm: false,
    editedItem: {
      id: null,
      command: '',
    },

    dialogCronNow: false,
  }),

  methods: {
    showRunCronNow() {
      this.dialogCronNow = true;
    },

    closeModal(modal) {
      this[modal] = false;
      this.clearState();
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = { ...item };
      this.dialogForm = true;
    },
    itemSaved() {
      this.items = [];
      this.updateTable();
    },
    updateTable() {
      this.loading = true;

      return this.$axios
        .get('api/v1/cronjob', {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...this.sortParams,
            search: this.search,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data.data;
          this.totalItems = res.data.total;
        });
    },
    clearState() {
      this.$nextTick(() => {
        this.editedItem = {};
        this.editedIndex = -1;
      });
    },
  },
};
</script>
